import {
  Box,
  Button,
  InputLabel,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React from "react";

const StyledBox = styled(Box)(({ theme }) => ({
  border: `0px solid ${theme.palette.divider}`,
  background: "white",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  gap: "2px",
  padding: "0",
  input: {
    padding: "6.53px 12px",
    "&::placeholder": {
      color: theme.palette.text.primary,
    },
  },
  fieldset: {
    border: "none !important",
  },
}));

const CustomInputLogin = ({
  label,
  placeholder,
  id,
  type = "string",
  onChange = () => {},
  isError = false,
  errorMsg = "",
  disabled = false,
  value,
  defaultValue,
}) => {
  return (
    <Box>
      <InputLabel
        htmlFor={id}
        sx={{ marginBottom: "10px", color: "black", fontWeight: "700" }}
      >
        {label}
      </InputLabel>
      <StyledBox>
        <TextField
          disabled={disabled}
          id={id}
          type={type}
          placeholder={placeholder}
          required
          fullWidth
          defaultValue={defaultValue}
          value={value || ""}
          onChange={(e) => {
            onChange(e);
          }}
          sx={{
            bgcolor: "white",
            border: "1px solid black",
            borderRadius: "4px",
          }}
        />
      </StyledBox>

      {isError && <Typography color="error">{errorMsg}</Typography>}
    </Box>
  );
};

export default CustomInputLogin;
